import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { purchaseOrderUpdateExternalItem } from '../../redux/actions/purchaseOrders';

const UpdateExternalItemModal = ({ payload, showUpdateExternalItemModal, setShowUpdateExternalItemModal, updateItem, currentId, currentName, currentSku, currentPrice, modalY }) => {
  const [name, setName] = useState(null);
  const [sku, setSku] = useState(null);
  const [price, setPrice] = useState(null);

  const changeName = (event) => {
    let value = event.target.value;
    
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setName(value);
  }

  const changeSku = (event) => {
    let value = event.target.value;
    
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value;
    
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setPrice(value);
  }


  const update = () => {
    let itemData = {};

    itemData.productId = currentId;
    itemData.variationId = null;
    itemData.is_external = true;
    itemData.productName = name || currentName;
    itemData.supplier_sku = sku || currentSku;
    itemData.supplier_price = price || currentPrice;
    itemData.minimumOrder = 1;

    updateItem(payload, itemData);
    setShowUpdateExternalItemModal(false);

    setName(null);
    setSku(null);
    setPrice(null);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  return (
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowUpdateExternalItemModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Update External Item</h3>
            <p>External items should be used sparingly, for products not tracked by your store.</p>

            <div className="fieldset">

              <div className="field field--medium">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Item Name</label>
                <input type="text" value={name} onFocus={focus} onBlur={blur} onChange={(e) => changeName(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">{currentName}</div>
              </div>

              <div className="field field--medium">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Supplier SKU</label>
                <input type="text" value={sku} onFocus={focus} onBlur={blur} onChange={(e) => changeSku(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">{currentSku}</div>
              </div>

              <div className="field field--medium">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Price</label>
                <input type="number" value={price} onFocus={focus} onBlur={blur} onChange={(e) => changePrice(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">{currentPrice}</div>
              </div>

            </div>

            <br/>

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Update External Item</button>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => ({
  updateItem: (payload, itemData) => dispatch(purchaseOrderUpdateExternalItem(payload, itemData))

});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateExternalItemModal);
